import { render, staticRenderFns } from "./ProfileLayout.vue?vue&type=template&id=20cc97b0&"
import script from "./ProfileLayout.vue?vue&type=script&lang=js&"
export * from "./ProfileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20cc97b0')) {
      api.createRecord('20cc97b0', component.options)
    } else {
      api.reload('20cc97b0', component.options)
    }
    module.hot.accept("./ProfileLayout.vue?vue&type=template&id=20cc97b0&", function () {
      api.rerender('20cc97b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Layout/ProfileLayout.vue"
export default component.exports